import { useEffect } from 'react'

export const useScrollRestoration = (scrollRef?: React.RefObject<HTMLElement>) => {
  useEffect(() => {
    const element = scrollRef?.current || window
    const path = window.location.pathname
    const savedScroll = sessionStorage.getItem(path)

    if (savedScroll) {
      const scrollValue = parseInt(savedScroll, 10)
      if (element === window) {
        window.scrollTo(0, scrollValue)
      } else {
        ;(element as HTMLElement).scrollTop = scrollValue
      }
    }

    const handleScroll = () => {
      const value = element === window ? window.scrollY : (element as HTMLElement).scrollTop
      sessionStorage.setItem(path, value.toString())
    }

    element.addEventListener('scroll', handleScroll)
    return () => element.removeEventListener('scroll', handleScroll)
  }, [scrollRef])
}
